import { useAuth } from '@/Context/AuthContext'
import ChartLockIssueService from '@/Service/ChartLockIssueService'
import React, { useEffect, useReducer } from 'react'
import { useLocation } from 'react-router-dom'
import { useDebounce } from 'use-debounce'
import CreateChartLockIssue from '../CreateChartLockIssue'
import Constant from '@/utils/Constant'
import HeaderCard from '@/Components/HeaderCard'
import { Dialog, DialogTrigger } from '@/Components/ui/dialog'
import { Button } from '@/Components/ui/button'
import BodyCard from '@/Components/BodyCard'
import { SquarePlus } from 'lucide-react'
import Datatable from '@/Components/Common/Datatable'
import { Input } from '@/Components/ui/input'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { checkPermission } from '@/utils/helper'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'
import ChartLockIssueColumn from './ChartLockIssueColumn'

const ChartLockIssue = () => {
    const { userInfo } = useAuth()

    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totalCharLockIssue: 0,
        isDataFetching: false,
        deleteConfirmationOpen: false,
        chartLockIssue: [],
        chartLockIssueSearch: '',
        isOpen: false,
        deleteId: [],
        allcheck: false,
        queryParam: {
            page: 1,
            chart_lock_issue: '',
        },
    })
    const [debouncedchartLockIssueSearch] = useDebounce(event.chartLockIssueSearch, Constant.DEBOUNCE_DELAY)

    const location = useLocation()

    const getChartLockIssue = async (page = 1) => {
        updateEvent({ isDataFetching: true, chartLockIssue: [] })
        try {
            const resp = await ChartLockIssueService.getChartLockIssue(event.queryParam)
            if (resp.data.success) {
                console.log('in data', resp.data.data)
                updateEvent({ chartLockIssue: resp.data.data, totalCharLockIssue: resp.data.pagination.total_record })
            }
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getChartLockIssue()
    }, [event.queryParam.page, event.queryParam.chart_lock_issue])

    useEffect(() => {
        updateEvent({
            queryParam: {
                ...event.queryParam,
                chart_lock_issue: debouncedchartLockIssueSearch,
            },
        })
    }, [debouncedchartLockIssueSearch])

    const deleteChartLockIssue = async (action) => {
        if (!action) {
            updateEvent({ deleteConfirmationOpen: false })
            return false
        }
        try {
            const resp = await ChartLockIssueService.deleteChartLockIssue(event.deleteId)
            if (resp.data.success) {
                getChartLockIssue()
            }
            updateEvent({ deleteId: [], allcheck: false })
        } catch (err) {
            console.log('err', err)
        }
        updateEvent({ deleteConfirmationOpen: false })
    }
    return (
        <>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {checkPermission(RequiredPermission.PROCESS.CREATE, userInfo.roles) && (
                        <Dialog open={event.isOpen} onOpenChange={() => updateEvent({ isOpen: !event.isOpen })}>
                            <DialogTrigger>
                                <Button className="bg-primary-btn hover:bg-primary-purpal">
                                    <SquarePlus />
                                    Add Chart Lock Issue
                                </Button>
                            </DialogTrigger>
                            <DialogTrigger></DialogTrigger>
                            <CreateChartLockIssue getChartLockIssue={getChartLockIssue} setIsOpen={(isOepn) => updateEvent({ isOpen: isOepn })} />
                        </Dialog>
                    )}

                    {checkPermission(RequiredPermission.PROCESS.DELETE, userInfo.roles) && event.deleteId.length > 0 && (
                        <Button
                            variant="outline"
                            onClick={() => updateEvent({ deleteConfirmationOpen: true })}
                            className={`ml-[10px] ${event.deleteId.length > 0 ? 'block' : 'hidden'}`}
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </HeaderCard>
            <ConfirmationPopup
                open={event.deleteConfirmationOpen}
                message="Are you sure you want to delete this permanently?"
                type={DeleteConfirmationTypeEnum.DELETE}
                setOpen={() => updateEvent({ deleteConfirmationOpen: !event.deleteConfirmationOpen })}
                handleAction={deleteChartLockIssue}
            />
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input
                        type="text"
                        value={event.chartLockIssueSearch}
                        onChange={(e) => updateEvent({ chartLockIssueSearch: e.target.value })}
                        placeholder="Chart Lock Issue"
                    />
                </div>
                <Datatable
                    columns={ChartLockIssueColumn()}
                    data={event.chartLockIssue}
                    totalDataCount={event.totalCharLockIssue}
                    allcheck={event.allcheck}
                    setAllcheck={event.setAllcheck}
                    deleteId={event.deleteId}
                    updateEvent={updateEvent}
                    loading={event.isDataFetching}
                />
            </BodyCard>
        </>
    )
}

export default ChartLockIssue
